import { useState, useEffect, useRef } from 'react'
import { NoRecords, PageLoader } from '../../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { DepositHistory } from '../api/index';
import { ArrowDown, ArrowUp, Search, Check, Copy, ExternalLink } from 'lucide-react';
import { useDebounce } from '../../../hooks/debounce';
import { transactionurl } from "../../../lib/transactionurl";
import { useToast } from "../../../hooks/usetoast"
import { useModalContext } from '../../../contexts/ModalContext';
import { copyToClipboard } from '../../../lib/copytoClipboard';
import { formatAddress } from '../../../utils/formatAddress';
import { useCheckAdminAccess } from '../../WhiteIp/api/whiteipapi';
import { logout } from '../../../hooks/logout';
import PermissionDenied from '../../common/permissionDenied';
import { WaitingLoader } from '../../../hooks/buttonLoad';
import BreadcrumbPagination from '../../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../../hooks/useBreadcrumbPagination';
import { displayValue } from '../../../hooks/export';

function ROUDeposit() {
    const toast = useToast()
    const { theme } = useModalContext()
    const [double, setDouble] = useState(false);
    const [copy, setCopy] = useState(false);

    const [tempPage, setTempPage] = useState(0);
    const [tempRows, setTempRows] = useState(25);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("desc")
    const searchText = useDebounce(search);
    const { data: getpolygonHistory, isLoading } = DepositHistory({
        page: searchText ? 0 : tempPage,
        type: "Deposit",
        currency: "rou",
        network: "polygon",
        size: tempRows,
        searchText,
        sortField: "createdAt",
        sortOrder: sortOrder
    })

    const totalRecords = getpolygonHistory?.data?.count || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(page);
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    const inputRef = useRef(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });
    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);



    const copytxnhashAddress = async data => {
        setDouble(data._id)
        await copyToClipboard(data.txnHash)
        toast.success("Transaction Hash copied")
        setTimeout(() => {
            setDouble()
        }, 800)
    }


    const copyAddress = async data => {
        setCopy(data._id)
        await copyToClipboard(data.address)
        toast.success("Address copied")
        setTimeout(() => {
            setCopy()
        }, 800)
    }


    const checkAdminMutation = useCheckAdminAccess();
    const [access, setAccess] = useState(true);

    useEffect(() => {
        checkAdminAccess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const checkAdminAccess = async () => {
        try {
            const obj = { page: 'Receive Management' };
            const checkAdminRes = await checkAdminMutation.mutateAsync(obj);
            if (!checkAdminRes?.data?.status) {
                setAccess(false);
                logout();
            } else {
                setAccess(true);
            }
        } catch (error) {
            setAccess(false);
        }
    };

    const renderCopyIcon = (isCopied, onClick, theme) => (
        isCopied ?
            <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : "black" }} />
            :
            <Copy onClick={onClick} size={20} className="ml-5" style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : "black" }} />
    );

    const renderTransactionLink = (hash, urlPrefix, isCopied, onClickCopy, theme) => (
        hash ? (
            <>
                {`${hash.slice(0, 3)}...${hash.slice(-3)}`}
                {renderCopyIcon(isCopied, onClickCopy, theme)}
                <a href={urlPrefix + hash} target="_blank" rel="noopener noreferrer" className="ml-2">
                    <ExternalLink style={{ marginLeft: "5px" }} size={20} />
                </a>
            </>
        ) : "-"
    );




    const renderBinanceHistoryTable = () => (
        getpolygonHistory?.data?.data?.length > 0 ?
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ maxWidth: "60px" }} align='center'>
                                        S.NO
                                    </TableCell>
                                    <TableCell align="center">Email</TableCell>
                                    <TableCell align="center">Address</TableCell>
                                    <TableCell align="center">Amount</TableCell>
                                    <TableCell align="center">Currency</TableCell>
                                    <TableCell align="center">TXNHASH</TableCell>
                                    <TableCell align="center">Date and Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder('desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getpolygonHistory?.data?.data?.map((row, i) => (
                                    <TableRow key={row?._id || i}>
                                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell align="center">{row.userEmail}</TableCell>
                                        <TableCell align="center">
                                            {formatAddress(row?.address) || "-"}
                                            {renderCopyIcon(copy === row._id, () => copyAddress(row), theme)}
                                        </TableCell>
                                        <TableCell className="text-nowrap" align="center">
                                            {row?.transferAmount ? (
                                                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                                                    {displayValue(row.transferAmount, 6)}                                                    {row?.currencyImage && (
                                                        <img
                                                            src={row.currencyImage}
                                                            alt="Currency Icon"
                                                            style={{
                                                                height: '20px',
                                                                width: '20px',
                                                                borderRadius: '50%',
                                                                verticalAlign: 'middle',
                                                                objectFit: 'cover',
                                                            }}
                                                        />
                                                    )}
                                                </span>
                                            ) : (
                                                '-'
                                            )}
                                        </TableCell>
                                        <TableCell className="text-nowrap" align="center">{row.currencySymbol}</TableCell>
                                        <TableCell align="center">
                                            {renderTransactionLink(row.txnHash, transactionurl["POL"], double === row._id, () => copytxnhashAddress(row), theme)}
                                        </TableCell>
                                        <TableCell align="center">
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
            :
            <NoRecords />
    )

    return (
        <>
            {isLoading ? (
                <WaitingLoader />
            ) : access ? (
                <section>
                    <div className=' d-flex justify-content-between'>
                        <h4>Receive ROU History</h4>
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                            <div className="ad_pg_cd_cnt">
                                <button className="ad_pg_cd_cnt w-100 bg-transparent border-0 p-0" >
                                    <div className="ad_pg_cd" style={{ backgroundColor: "#052c65" }}>
                                        <div className="ad_pg_cd_rcnt tp" style={{ marginLeft: "80px" }}>
                                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                                <div className="col-auto ad_pg_cd_c">
                                                    <div className="ad_pg_cd_lb">ROU Deposit</div>
                                                    <div className="ad_pg_cd_vl">{Number(getpolygonHistory?.data?.TotalRouDeposit ?? 0).toFixed(2)} ROU</div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="ad_pg_cd_rcnt bm d-none">
                                            <div className="row justify-content-between align-items-center ad_pg_cd_r">
                                                <div className="col-auto ad_pg_cd_c">
                                                    <div className="ad_pg_cd_lb"></div>
                                                    <div className="ad_pg_cd_vl"></div>

                                                </div>
                                                <div className="col-auto ad_pg_cd_c">

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="ad_pg_bx bg-white p-3 mt-3 mt-3">
                        <div className='d-flex justify-content-between align-items-center mb-2'>
                            <div className='col-md-4'>
                                <div className="input-group">
                                    <span className="input-group-icon">
                                        <Search size={20} color='#aaa9a9' />
                                    </span>
                                    <input
                                        type="text"
                                        ref={inputRef}
                                        onChange={(e) => setSearch(e.target.value)}
                                        className="form-control"
                                        placeholder="Search Address"
                                        value={search}
                                    />
                                </div>
                            </div>
                        </div>
                        {isLoading ? <PageLoader /> : renderBinanceHistoryTable()}
                    </div>
                </section>
            ) : (
                <PermissionDenied />
            )}


        </>
    )
}

export default ROUDeposit